import * as React from "react";

import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";

import { DefaultCardContents } from "./DefaultCardContents";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const PackageCardMobile = ({ packageItem, index, language }: PackageCardProps) => (
  <UitkCardAloha className="all-t-margin-three">
    <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
      <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
    </UitkFigure>
    <UitkLayoutPosition type="relative" cloneElement={true}>
      <DefaultCardContents packageItem={packageItem} index={index} language={language} overImage={true} />
    </UitkLayoutPosition>
  </UitkCardAloha>
);
